import { render, staticRenderFns } from "./AiPicture.vue?vue&type=template&id=0c922ba6&scoped=true"
import script from "./AiPicture.vue?vue&type=script&lang=js"
export * from "./AiPicture.vue?vue&type=script&lang=js"
import style0 from "./AiPicture.vue?vue&type=style&index=0&id=0c922ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c922ba6",
  null
  
)

export default component.exports